/**!*******************************************************************
 *
 * Copyright (c) Epic AI GmbH. All rights reserved.
 * Author:  Alexander Claas
 * 
 ********************************************************************!*/

import { getAuth } from "firebase/auth";
import { getFirestore, getDoc, doc } from "firebase/firestore";
import { store } from "@/store";
import { UserStore } from "@/store/constants";

export const useAuthService = async () => {
  if(store.getters[UserStore.Getters.IS_SIGNED_IN]) return;
  await new Promise((resolve) => {
    getAuth().onAuthStateChanged(async user => {
      if(user) {
        store.commit(UserStore.Mutations.SIGN_IN, user);
        const idToken = await user.getIdToken(true);
        store.commit(UserStore.Mutations.SET_ID_TOKEN, idToken);
        const userDoc = await getDoc(doc(getFirestore(), "users/" + user.uid));
        const orgId = userDoc.data()?.root_organization;
        if(orgId) store.commit(UserStore.Mutations.SET_ORGANIZATION, orgId);
        resolve(null);
      } else {
        store.dispatch(UserStore.Actions.SIGN_OUT);
        resolve(null);
      }
    });
  });
}

//TODO handle idToken updates and push new token to vuex store

export const signOut = async () => {
  await getAuth().signOut();
}